import DetailModal from './DetailModal';

export default DetailModal;
